import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconDoorHanger: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconDoorHanger"><Path d="M12 1.01489C8.14546 1.01489 5 4.09277 5 7.91489V9.68989H9.625V7.91489C9.625 6.64219 10.6769 5.58989 12 5.58989C13.3231 5.58989 14.375 6.64219 14.375 7.91489V8.03478C14.375 9.46891 13.4418 10.7527 12.0422 11.2117L8.3653 12.4178C6.36207 13.0748 5 14.9246 5 17.02V23.0149H19V7.91489C19 4.09277 15.8545 1.01489 12 1.01489Z" fill="currentColor"/></CentralIconBase>;
});

export default IconDoorHanger;
